import React from "react";
import logo from "../assets/logo.png";
import { Link } from "react-router-dom";
import { MdOutlineMarkEmailUnread } from "react-icons/md";
import search from '../assets/icons/search.png';
import email from '../assets/icons/email.png';
import location from '../assets/icons/location.png';
import call from '../assets/icons/call.png';

const Footer = () => {
  const handleSubscribe = (event) => {
    event.preventDefault();
    const emailAddress = new FormData(event.currentTarget).get('subscriberEmail');
    window.location.href = `mailto:info@millenniumrealtysf.com?subject=${encodeURIComponent('Newsletter subscription')}&body=${encodeURIComponent(`Please add ${emailAddress} to the Millennium Realty newsletter.`)}`;
  };

  return (
    <footer className="w-full h-full bg-black px-5 pt-12 sm:px-8 lg:px-16 lg:pt-20">
      <div className="grid grid-cols-1 items-start gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-12">
        <div className="flex min-w-0 flex-col items-start gap-6">
          <img src={logo} alt="Millennium Realty" className="h-auto w-44 object-contain" />
          <p className="font-light text-base leading-relaxed text-white/90 sm:text-lg">
            With over 20 years of industry experience, we provide professional
            real estate and property management solutions across the San
            Francisco and Bay Area. From residential homes to commercial
            properties and shopping centers, our licensed team is dedicated to
            protecting your investment and maximizing your returns.
          </p>
        </div>
         <div className="flex min-w-0 flex-col items-start gap-6">
         <h1 className="font-bold text-[20px] text-gradient">Main Links</h1>
           <div className="flex justify-start items-start flex-col gap-[0.8rem]">
                <Link to="/" className="text-base text-white link sm:text-lg">Home</Link>
                <Link to="/property" className="text-base text-white link sm:text-lg">Property Management</Link>
                <Link to="/rent" className="text-base text-white link sm:text-lg">For Rent/Lease</Link>
                <Link to="/property-listing" className="text-base text-white link sm:text-lg">Property Listing</Link>

                <Link to="/about" className="text-base text-white link sm:text-lg">About Us</Link>
           </div>
        </div>
         <div className="flex min-w-0 flex-col items-start gap-6">
         <h1 className="font-bold text-[20px] text-gradient">Quick Links</h1>
           <div className="flex justify-start items-start flex-col gap-[0.8rem]">
                <Link to="/terms" className="text-base text-white link sm:text-lg">Terms & Conditions</Link>
                <Link to="/privacy" className="text-base text-white link sm:text-lg">Privacy Policy</Link>
                <Link to="/refund-policy" className="text-base text-white link sm:text-lg">Refund Policy</Link>
                <Link to="/contact" className="text-base text-white link sm:text-lg">Contact Us</Link>
                
           </div>
        </div>
          <div className="flex min-w-0 flex-col items-start gap-6">
         <h1 className="font-bold text-[20px] text-gradient">Subscribe to Our Newsletter</h1>
           <div className="flex justify-start items-start flex-col gap-[0.8rem]">
               <form onSubmit={handleSubscribe} className="py-[0.3rem] flex justify-between items-center pl-[1.5rem] pr-[0.3rem] gap-[10px] w-[100%] bg-[#141414] rounded-lg ">
                           {/* Input + Icon */}
                           <div className="flex items-center text-gray-500 gap-[0.5rem] h-[35px] flex-1">
                             <MdOutlineMarkEmailUnread size={"26px"} color="#999999" />
                             <input
                               type="email"
                               name="subscriberEmail"
                               autoComplete="email"
                               required
                               aria-label="Email address for newsletter"
                               placeholder="Enter Your Email"
                               className="outline-none w-full bg-transparent text-[18px] text-white"
                             />
                           </div>
                          <button type="submit" aria-label="Subscribe by email" className="flex min-h-11 min-w-11 items-center justify-center rounded-lg">
                            <img src={search} alt="" />
                          </button>
                         </form>
                         <div className="flex items-start justify-start gap-[0.5rem]">
                              <img src={location} alt="" />
                              <a href="https://www.google.com/maps/search/?api=1&query=2480+Mission+Street+Suite+108+San+Francisco+CA+94110" target="_blank" rel="noreferrer" className="text-[18px] font-light text-white hover:text-[#EEC24B]">2480 Mission Street Suite 108 San Francisco, CA 94110</a>
                         </div>
                         <div className="flex items-start justify-start gap-[0.5rem]">
                              <img src={email} alt="" />
                              <a href="mailto:info@millenniumrealtysf.com" className="break-all text-[18px] font-light text-white hover:text-[#EEC24B]">info@millenniumrealtysf.com</a>
                         </div>
                         <div className="flex items-start justify-start gap-[0.5rem]">
                              <img src={call} alt="" />
                              <a href="tel:+14156107765" className="text-[18px] font-light text-white hover:text-[#EEC24B]">415-610-7765</a>
                         </div>
                    
                
           </div>
        </div>
      </div>
      <div
  className="w-full h-[2px] rounded-full mt-[2rem]"
  style={{
    background: "linear-gradient(147.2deg, #DCBA45 0.83%, #FFE568 25.03%, #E8B641 55.47%, #D8AD42 78.88%)",
  }}
/>
  <div className="flex flex-col gap-2 px-2 py-5 text-center sm:flex-row sm:justify-between sm:text-left">
       <p className="text-sm font-light text-white sm:text-base">© 2026 Copyright | Millennium Realty | All Rights Reserved</p>
       <p className="text-sm font-light text-white sm:text-base">Powered By Design <span className="text-gradient">Verse Studios</span></p>
  </div>
    </footer>
  );
};

export default Footer;
